import React, { useState, useEffect, useContext, useRef } from "react";
import "../NewEnquiry.css";
import classes from "../../TrucksAvailable.module.css";
import edStyles from "./editenquiry.module.css";
import Select from "react-select/creatable";
// import Autosuggestor from "../../AutoComplete/AutoCompleteTransporter";
import AutoComplete from "../../AutoComplete/AutocompletetransporterV2";
import Rating from "react-rating";
import { toast } from "react-toastify";
import FeedbackForm from "../../../Freightrates1/BenchmarkMasterView/RatingsandFeedback";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import mixpanel from "mixpanel-browser";
import { Activity, currentRequestTimeStamp } from "../../../../Constants";
import NewProfileModal from "../../../Shared/NewTransporterProfileModal/NewProfileModal";
import Loader from "../../../Loader";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";

import { checkModuleAccess } from "../../../../Utility";
import MultiSelectWithCheckbox from "../../../Shared/MultiSelectCheckbox/MultiSelectCheckbox";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const EditEnquiry = ({ item, TruckTypes, tenurelist, getEnquiries = "", isSuperAdmin = false }) => {
  const [selectedTrucks, setselectedTrucks] = useState();
  const [contract_tenure, setContract_tenure] = useState();
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [date_of_placement, setDate_of_placement] = useState();
  const [focussed, setFocussed] = useState(null);
  const [termsAndCondition, setTermsAndCondition] = useState();
  const [active, setactive] = useState(0);
  const [truck_type_list, setTruck_type_list] = useState([]);
  const [tenure_list, setTenure_list] = useState([]);
  const { companyProfile } = useContext(UserApiContext);
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  const [initialTransporters, setInitialTransporters] = useState([]);
  const [show, setshow] = useState(false);
  const [hasTermsChanged, setHasTermsChanged] = useState(false);
  const [hasDueDateChanged, setHasDueDateChanged] = useState(false);
  const [hasTenureChanged, setHasTenureChanged] = useState(false);
  const [hasTransportersChanged, setHasTransportersChanged] = useState(false);
  const [truck_required, setTruck_required] = useState();
  const [document_details, setDocument_details] = useState("");
  const [tonnage, setTonnage] = useState("");
  const [capacity, setCapacity] = useState("");
  const [product_types, setProduct_types] = useState([]);
  const [materialCategories, setMaterialCategories] = useState([]);

  const [hasInvoiceChanged, setHasInvoiceChanged] = useState(false);
  const [hasWeightChanged, setHasWeightChanged] = useState(false);
  const [hasProductsChanged, setHasProductsChanged] = useState(false);

  const truckReq = useRef(null);
  const [company_id, setCompany_id] = useState("");
  const tncSubmitRef = useRef();


  var user_name = localStorage.getItem("userdetails");
  var userid = localStorage.getItem("user_id");
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const onEditTruckRequired = (value) => {
    setTruck_required(value);
    setFocussed("trucks");
  };

  useEffect(() => {
    if (focussed === "trucks" && truckReq.current) {
      truckReq.current.focus();
    }
  }, [focussed]);

  const changeHandlerTransporter = (e, transporter) => {
    const list = [...newtransporter_list];
    const index = list.findIndex(
      (t) => t.transporter_id === transporter.transporter_id
    );
    if (index !== -1) {
      list[index].ischecked = e.target.checked;
      setnewtransporter_list(list);
      setHasTransportersChanged(true);
    }
  };

  const handleSaveAll = () => {
    if (tonnage !== "" && tonnage !== undefined && tonnage !== null && Number(tonnage) < 0) {
      toast.error("Weight cannot be negative");
      return;
    }
    Activity([
      {
        screen: "Truck Available",
        module: "My Enquiries",
        user_activity: "Edit save Button",
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    // Track MixPanel
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - edit enquiry",
      Data: `lane: ${item.lane_details?.origin?.location_name} to ${item.lane_details?.destination?.location_name
        }, truck type : ${item?.lane_details?.truck_types?.[0]?.label
        }, contract tenure : ${contract_tenure?.[0]?.label || ""
        }, placement date: ${date_of_placement}, enquiry id: ${item.truck_enquiry_id
        }, trucks required: ${truck_required}`,
      Definition: `user has clicked on edit save button`,
    });

    const payload = {
      truck_enquiry_id: item.truck_enquiry_id,
    };

    if (hasDueDateChanged) {
      payload.due_date = date_of_placement;
    }
    if (hasTenureChanged) {
      payload.contract_tenure = contract_tenure;
    }
    if (hasTermsChanged) {
      payload.terms_and_condition = termsAndCondition;
    }
    if (hasTransportersChanged) {
      const initialIds = initialTransporters ? initialTransporters.map((t) => t.transporter_id) : [];
      payload.added_transporter_list = newtransporter_list
        .filter((t) => (t.ischecked || t.isChecked) && !initialIds.includes(t.transporter_id))
        .map((t) => ({
          transporter_id: t.transporter_id,
          transporter_name: t.transporter_name,
          ischecked: true,
        }));
    }
    if (hasInvoiceChanged) {
      payload.sales_invoice_number = document_details;
    }
    if (hasWeightChanged) {
      payload.tonnage = (tonnage === "0" || tonnage === 0 || !tonnage) ? "" : String(tonnage);
      payload.tonnage_unit = capacity;
    }
    if (hasProductsChanged) {
      payload.product_types = product_types;
    }

    setshow(true);
    axios
      .post(`${Urls.spot}?field=edit_enquiry_v2`, payload)
      .then((res) => {
        if (res.data?.status === false) {
          toast.info(res.data?.message || "Indent is already created");
          setshow(false);
          return;
        }
        setshow(false);
        toast.success("Enquiry Updated Successfully.");
        getEnquiries("active");
        setHasDueDateChanged(false);
        setHasTenureChanged(false);
        setHasTermsChanged(false);
        setHasTransportersChanged(false);
        setHasInvoiceChanged(false);
        setHasWeightChanged(false);
        setHasProductsChanged(false);
        document.getElementById("close_contactus")?.click();
      })
      .catch((e) => {
        setshow(false);
        console.log(e);
        toast.error("Failed to update enquiry.");
      });
  };

  /**
   * useEffect hook to fetch data and update state on component mount or when companyProfile changes.
   */
  useEffect(() => {
    setshow(true);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - edit enquiry",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ''} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user opened and viewed edit enquiry modal`,
    });
    if (item && item.truck_enquiry_id) {
      axios
        .get(`${Urls.spot}?field=get_transporters&truck_enquiry_id=${item.truck_enquiry_id}`)
        .then((res) => {
          setshow(false);
          if (res.data && res.data.benchmark_transporter_list) {
            const mapped = res.data.benchmark_transporter_list.map((t) => ({
              ...t,
              ischecked: t.isChecked !== undefined ? t.isChecked : t.ischecked,
            }));
            setnewtransporter_list(mapped);
            setInitialTransporters(mapped);
          }
        })
        .catch((err) => {
          setshow(false);
          console.error("Failed to fetch transporters", err);
        });
    } else {
      setshow(false);
    }

    if (companyProfile && companyProfile.domain_data) {
      if (
        companyProfile.domain_data.company_id &&
        companyProfile.domain_data.company_id !== ""
      ) {
        setCompany_id(companyProfile.domain_data.company_id);
      }
    }

    setTruck_type_list(TruckTypes);
    setTenure_list(tenurelist);
    setselectedTrucks(item.lane_details?.truck_types);
    setTruck_required(item.lane_details?.truck_required);
    setContract_tenure(item.lane_details?.contract_tenure);
    setDate_of_placement(item.lane_details?.due_date);
    setTermsAndCondition(item.terms_and_condition);
    setDocument_details(item.lane_details?.document_details || item.lane_details?.sales_invoice_number || "");
    setTonnage(item.lane_details?.tonnage || "");
    setCapacity(item.lane_details?.capacity || item.lane_details?.tonnage_unit || "MT");
    setProduct_types(item.lane_details?.product_types || []);

    if (item.truck_enquiry_id && companyProfile?.domain_data?.company_id) {
      axios
        .get(
          `${Urls.spot}?field=get_material_types&company_id=${companyProfile.domain_data.company_id}`
        )
        .then((res) => {
          if (res?.data?.length > 0) {
            setMaterialCategories(res?.data);
          }
        })
        .catch(console.log);
    }

  }, [companyProfile]);

  /**
 * Formats a date string to 'YYYY-MM-DD'.
 *
 * @param {string} inputdate - The date to be formatted.
 * @returns {string} The formatted date string.
 */
  const DateFormat = (inputdate) => {
    var mindate = new Date(inputdate);
    var day = ("0" + mindate.getDate()).slice(-2);
    var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
    var year = mindate.getFullYear();
    return year.toString() + "-" + month.toString() + "-" + day.toString();
  };

  /**
   * Handles change in truck types selection.
   *
   * @param {Object} value - The selected truck type value.
   */
  const onChangeTruckTypes = (value) => {
    var list = [];
    list.push(value);
    setselectedTrucks(list);
  };

  /**
   * Handles change in contract tenure selection.
   *
   * @param {Object} value - The selected tenure value.
   */
  const onChangeTenure = (value) => {
    var list = [];
    list.push(value);
    setContract_tenure(list);
    setHasTenureChanged(true);
  };

  /**
   * Handles editing of date of placement.
   *
   * @param {string} value - The new date value.
   * @param {Object} item - The current item being edited.
   * @param {number} index - The index of the item in the list.
   */
  const onEditDate = (value, item, index) => {
    // console.log(value)
    setDate_of_placement(value);
    setFocussed("date");
    setHasDueDateChanged(true);
  };

  // const oncloseHandler = () => {
  //     document.getElementById("close_contactus").click()
  // }

  /**
   * React component for viewing and editing transporters.
   *
   * @component
   */
  const ViewLsp = ({ transporters, item }) => {
    const [searchText, setSearchText] = useState("");

    /**
     * Adds a transporter to the list if not already present.
     *
     * @param {Object} e - The event object containing transporter details.
     */
    const addtolist = (e) => {
      var list = [];
      var temp = [...newtransporter_list];
      temp.map((data) => {
        list.push(data.transporter_name);
      });
      if (!list.includes(e.transporter_name)) {
        e.ischecked = true;
        temp.push(e);
        setSearchText();
        setnewtransporter_list(temp);
        setHasTransportersChanged(true);
      } else {
        toast.info("Transporter already exists");
        setSearchText();
      }
    };

    /**
     * Handles changes in transporter selection.
     *
     * @param {Object} e - The event object containing change information.
     * @param {Object} value - The transporter object being changed.
     */
    const handleOpenProfile = (e, transporter) => {
      e.stopPropagation();
      setactiveTransporter({
        id: transporter.transporter_id,
        name: transporter.transporter_name,
      });
      setOpenProfileModal(true);
    };

    const handleCloseModal = () => {
      setOpenProfileModal(false);
      setactiveTransporter({ id: "", name: "" });
    };

    const [activeTransporter, setactiveTransporter] = useState({ id: "", name: "" });
    const [openProfileModal, setOpenProfileModal] = useState(false);

    return (
      <div className={edStyles.container}>
        {Array.isArray(newtransporter_list) && newtransporter_list.length > 0 ? (
          <>
            {/* Summary bar */}
            <div className={edStyles.summaryBar}>
              <span className={edStyles.summaryCount}>
                <i className="fa fa-users" style={{ marginRight: "8px" }} />
                {newtransporter_list.length} {newtransporter_list.length === 1 ? "Transporter" : "Transporters"}
              </span>
              {newtransporter_list.filter(t => t.ischecked).length > 0 && (
                <span className={edStyles.summaryTag}>
                  <i className="fa fa-check" style={{ marginRight: "6px" }} />
                  {newtransporter_list.filter(t => t.ischecked).length} Selected
                </span>
              )}
            </div>

            <div className={edStyles.transporterListContainer}>
              {newtransporter_list.map((transporter, index) => {
                if (transporter.transporter_id && transporter.transporter_id !== "") {
                  const isChecked = transporter.ischecked === true;
                  const isDisabled = initialTransporters
                    ? initialTransporters
                      .filter((t) => t.ischecked)
                      .some((t) => t.transporter_id === transporter.transporter_id)
                    : false;

                  return (
                    <div
                      className={`${edStyles.transporterCard} ${isChecked ? edStyles.cardSelected : ""}`}
                      key={`transporter${index}`}
                      onClick={() => !isDisabled && changeHandlerTransporter({ target: { checked: !isChecked } }, transporter)}
                    >
                      {/* Checkbox Icon */}
                      <div className={`${edStyles.checkboxWrap} ${isChecked ? edStyles.checked : ""} ${isDisabled ? edStyles.disabledCheckbox : ""}`}>
                        <div className={edStyles.customCheckbox}>
                          <i className="fa fa-check" />
                        </div>
                      </div>

                      {/* Serial Number */}
                      <span className={edStyles.serialNum}>{index + 1}</span>

                      {/* Name */}
                      <div className={edStyles.nameWrap}>
                        <button
                          className={edStyles.profileButton}
                          onClick={(e) => handleOpenProfile(e, transporter)}
                          title={transporter.transporter_name}
                        >
                          {transporter.transporter_name}
                        </button>
                      </div>

                      {/* Rating */}
                      <div className={edStyles.ratingWrap}>
                        <Rating
                          initialRating={transporter.overall_rating || 0}
                          readonly={true}
                          emptySymbol={`fa fa-star-o ${edStyles.starEmpty}`}
                          fullSymbol={`fa fa-star ${edStyles.starFull}`}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>

            {/* Add Transporter */}
            <div className={edStyles.addInputWrap}>
              <AutoComplete
                  placeholder="Add Transporters"
                  value={searchText}
                  onChange={(val) => setSearchText(val)}
                  onSelect={(obj) => setSearchText(obj?.transporter_name || "")}
                  getResults={(obj) => addtolist(obj)}
                  type="transporter"
                  classNamePrefix="transporter-select"
                />
            </div>
          </>
        ) : (
          <div className={edStyles.noTransporters}>
            <i className={`fa fa-inbox ${edStyles.emptyIcon}`} />
            <span>No transporters shortlisted for this enquiry.</span>
          </div>
        )}

        {openProfileModal && activeTransporter?.id !== "" && (
          <NewProfileModal
            isOpen={openProfileModal}
            onClose={handleCloseModal}
            transporter_id={activeTransporter.id}
            transporter_name={activeTransporter.name}
            screenName={"LoRRI Adhoc"}
            moduleName={"My Enquiries"}
            transporter_list={newtransporter_list}
          />
        )}
      </div>
    );
  };

  /**
   * EditEnquiry component handles the editing of truck enquiries.
   *
   * @component
   * @returns {React.ReactElement} The EditEnquiry component.
   */
  /**
   * Submits the new terms and conditions for the truck enquiry.
   *
   * @function
   * @param {string} terms - The new terms and conditions to be submitted.
   */
  const submitnewterms = (terms) => {
    handleSaveAll(terms);
  };

  return (
    <div className={edStyles.container}>
      <Loader show={show} />

      {/* Tab Navigation */}
      <div className={edStyles.tabContainer}>
        <button
          type="button"
          className={`${edStyles.tabButton} ${active === 0 ? edStyles.tabActive : ""}`}
          onClick={() => setactive(0)}
        >
          Enquiry Details
        </button>
        <button
          type="button"
          className={`${edStyles.tabButton} ${active === 1 ? edStyles.tabActive : ""}`}
          onClick={() => setactive(1)}
        >
          Terms and Conditions
        </button>
        <button
          type="button"
          className={`${edStyles.tabButton} ${active === 2 ? edStyles.tabActive : ""}`}
          onClick={() => setactive(2)}
        >
          Transporter List
        </button>
      </div>

      <div style={{ display: active === 0 ? "block" : "none" }}>
        <div className={edStyles.container}>
          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Truck Type</label>
            <div className={edStyles.selectWrapper}>
              <Select
                options={truck_type_list}
                isMulti={false}
                onChange={(value) => onChangeTruckTypes(value)}
                value={selectedTrucks}
                className={"Truck_Type_Select"}
                classNamePrefix={"Truck_Prefix"}
                defaultValue=""
                isDisabled={true}
              />
            </div>
          </div>
          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Truck Required</label>
            <input
              type="number"
              ref={truckReq}
              className={`${edStyles.input} ${edStyles.inputDisabled}`}
              value={truck_required || ""}
              onChange={(e) => onEditTruckRequired(e.target.value)}
              disabled
            />
          </div>
          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Date of Placement</label>
            <input
              type="date"
              className={edStyles.input}
              value={date_of_placement || ""}
              min={DateFormat(new Date())}
              onInput={(e) => onEditDate(e.target.value)}
            />
          </div>
          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Contract Tenure</label>
            <div className={edStyles.selectWrapper}>
              <Select
                options={tenure_list}
                isMulti={false}
                onChange={(value) => onChangeTenure(value)}
                value={contract_tenure}
                className={"Truck_Type_Select"}
                classNamePrefix={"Truck_Prefix"}
              />
            </div>
          </div>

          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Sales Invoice Number</label>
            <input
              type="text"
              className={edStyles.input}
              value={document_details || ""}
              onChange={(e) => {
                setDocument_details(e.target.value);
                setHasInvoiceChanged(true);
              }}
              placeholder="Enter SIN number"
            />
          </div>

          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Weight</label>
            <div style={{ display: "flex", gap: "10px", alignItems: "center", flex: 1, flexWrap: "nowrap" }}>
              <input
                type="number"
                min="0"
                className={edStyles.input}
                style={{ flex: 1 }}
                value={tonnage || ""}
                onKeyDown={(e) => {
                  if (["-", "e", "E"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val !== "" && Number(val) < 0) {
                    toast.error("Weight cannot be negative");
                    return;
                  }
                  setTonnage(val);
                  setHasWeightChanged(true);
                }}
                placeholder="Enter weight"
              />
              <div className={edStyles.unitButtons}>
                <button
                  type="button"
                  className={`${edStyles.unitBtn} ${capacity === "MT" ? edStyles.unitBtnActive : ""}`}
                  onClick={() => {
                    setCapacity("MT");
                    setHasWeightChanged(true);
                  }}
                >
                  MT
                </button>
                <button
                  type="button"
                  className={`${edStyles.unitBtn} ${capacity === "KG" ? edStyles.unitBtnActive : ""}`}
                  onClick={() => {
                    setCapacity("KG");
                    setHasWeightChanged(true);
                  }}
                >
                  KG
                </button>
              </div>
            </div>
          </div>

          <div className={edStyles.formGroup}>
            <label className={edStyles.label}>Product Types</label>
            <div className={edStyles.selectWrapper}>
              <MultiSelectWithCheckbox
                options={materialCategories}
                onChange={(e) => {
                  setProduct_types(e);
                  setHasProductsChanged(true);
                }}
                value={product_types}
              />
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: active === 1 ? "block" : "none" }}>
        <FeedbackForm
          tncRef={tncSubmitRef}
          editMode={true}
          qualitativeInputs={termsAndCondition}
          setQualitativeInputs={(value) => {
            setTermsAndCondition(value);
            setHasTermsChanged(true);
          }}
          from="editenquiry"
          company_id={company_id}
          onsubmit={submitnewterms}
          notnc={false}
          saveButtonText="Submit"
          buttonID="QualitativeFeedBackForm_Update"
          isSuperAdmin={isSuperAdmin}
        />
      </div>

      <div style={{ display: active === 2 ? "block" : "none" }}>
        <ViewLsp item={item} transporters={newtransporter_list} />
      </div>

      <center className="mt-4">
        <button
          onClick={() => {
            if (hasTermsChanged && tncSubmitRef.current) {
              tncSubmitRef.current.click();
            } else {
              handleSaveAll();
            }
          }}
          className={edStyles.saveButton}
        >
          Save Changes
        </button>
      </center>
    </div>
  );
};

export default EditEnquiry;
